import { isAudioFile } from '@/components/media/RecordedAudio';

/**
 * Текст сдачи домашки: отделить запись голоса от написанного.
 *
 * ⚠️ ЗАЧЕМ. Запись голоса из урока сервер кладёт в текст сдачи ССЫЛКОЙ
 * (`queueForReview` в progress-service копирует ответ блока `audio_record` в
 * `content`). На копии боевой базы 10.09.2026 так устроены 1357 сдач из 2169:
 * текст — только ссылка, mp4 802, webm 555. Куратор видел голый адрес вместо
 * записи и слушать его приходилось в новой вкладке.
 *
 * Ссылка считается записью по расширению (`isAudioFile`) или по папке
 * `homework_audio` — там хранятся только голосовые ответы. Прочие ссылки
 * остаются в тексте как есть.
 */
const URL_RE = /https?:\/\/[^\s<>"']+|\/api\/v1\/files\/o\/[^\s<>"']+/g;

export function splitHomeworkContent(content: string | null | undefined): { text: string; audio: string[] } {
  const audio: string[] = [];
  const text = (content ?? '')
    .replace(URL_RE, (match) => {
      // Точка или скобка сразу за ссылкой — конец предложения, а не часть адреса.
      const [, url, tail] = /^(.*?)([.,;:!?)\]]*)$/.exec(match) ?? [match, match, ''];
      if (isAudioFile(url) || url.includes('/files/o/homework_audio/')) {
        audio.push(url);
        return tail === match ? '' : tail;
      }
      return match;
    })
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return { text, audio };
}
